import { REQUEST_METHOD } from '@laramie/ui';
import { APIS } from '../../../config/apis';
import { ServerRequestAsync } from '../../../utils/apiweb';

export const FetchCartelDefinicion = async () => {
    const response = await ServerRequestAsync(REQUEST_METHOD.GET, null, true, APIS.URLS.CARTEL_DEFINICION);
    if (response.ok) {
        return await response.json();
    }
    throw new Error('Error al obtener definición de cartel');
}
